export const LngToNum = (lng)=>{
    switch(localStorage.getItem("i18nextLng")){
            case "es" :
                return 0
            case "en" :
                return 1
            case "fr" :
                return 2
            case "ar":
                return 3
            case "zh":
                return 4
            case "ru":
                return 5
            case "pt":
                return 6
            case "it":
                return 7
            default:
                return 0
         }

}

export const words =[

    //ESPAÑOL
    [
    "Economía", "ONU", "Cambio", "Agenda", "Sociedad", "Flagelo", "Problemática", "Solución",
    "Catalizador", "Frente", "Amenaza", "Órgano", "Seguridad", "Tiempo", "Estrategia", "Fácil",
    "Difícil", "Riesgo", "Problema", "Sesgado", "Confuso", "Ejemplo", "Región", "Camino", "Crimen",
    "Inmensidad", "Igual", "Abismo", "Ideología", "Estabilidad", "Análisis", "Poder", "Futuro", "Dialogo",
    "Derecho Internacional", "Conflicto", "Desarrollo", "Cooperación", "Paz", "Experiencia", "Datos",
    "Mecanismos", "Instituciones", "Gobierno", "Tecnología", "Fortalecimiento", "Fronteras", "Adaptación",
    "Participación", "Limitaciones", "Panorama", "Afán", "Crisis", "Principios", "Propuesta", "Delegados",
    "Delegaciones", "Justicia", "Alianza", "Potencia", "Años", "Pueblo", "Unidad", "Hipócritas", "Mediocres",
    "Falso", "Verdadero", "Mentirosos", "Irracional", "Miedo", "Liderazgo", "Respeto", "Peligro", "Sociedad",
    "Comunidad Internacional", "Trabajo", "Esfuerzo", "Lucha", "Compromiso", "Evidencia", "Desigualdad",
    "Países", "Objetivos", "Dilema", "Ética", "Moral", "Amenaza", "Estados", "Conocimiento", "Imperialismo",
    "Capitalismo", "Comunismo", "Inversión", "Dinero", "Sesión", "Diferente", "Discursos", "Necesidad", "Esencial",
    "Estancamiento", "Tratado", "Recinto", "Deuda", "Mundo", "Lazo", "Fuerza", "Excelencia"
    ],

    //INGLES
    [
        "Economy", "UN", "Change", "Agenda", "Society", "flagellum", "Problem", "Solution",
    "Catalyst", "Front", "Threat", "Organ", "Security", "Time", "Strategy", "Easy",
    "Difficult", "Risk", "Problem", "Skewed", "Confusing", "Example", "Region", "Path", "Crime",
    "Immensity", "Same", "Abyss", "Ideology", "Stability", "Analysis", "Power", "Future", "Dialogue",
    "International Law", "Conflict", "Development", "Cooperation", "Peace", "Experience", "Data",
    "Mechanisms", "Institutions", "Government", "Technology", "Strengthening", "Frontiers", "Adaptation",
    "Participation", "Limitations", "Perspective", "Eagerness", "Crisis", "Principles", "Proposal", "Delegates",
    "Delegations", "Justice", "Alliance", "Power", "Years", "People", "Unity", "Hypocrites", "Mediocres",
    "False", "True", "Liars", "Irrational", "Fear", "Leadership", "Respect", "Danger", "Society",
    "International Community", "Work", "Effort", "Struggle", "Commitment", "Evidence", "Inequality",
    "Countries", "Objectives", "Dilemma", "Ethics", "Moral", "Threat", "States", "Knowledge", "Imperialism",
    "Capitalism", "Communism", "Investment", "Money", "Session", "Different", "Speeches", "Necessity", "Essential",
    "Stalemate", "Treaty", "Precinct", "Debt", "World", "Noose", "Strength", "Excellence"
    ],

    //Frances
    [
        "Économie", "ONU", "Changement", "Agenda", "Société", "flagelle", "Problème", "Solution",
        "Catalyseur", "Avant", "Menace", "Orgue", "Sécurité", "Temps", "Stratégie", "Facile",
        "Difficile", "Risque", "Problème", "Skewed", "Confusion", "Exemple", "Région", "Chemin", "Crime",
        "Immensité", "Même", "Abîme", "Idéologie", "Stabilité", "Analyse", "Puissance", "Avenir", "Dialogue",
        "Droit international", "Conflit", "Développement", "Coopération", "Paix", "Expérience", "Données",
        "Mécanismes", "Institutions", "Gouvernement", "Technologie", "Renforcement", "Frontières", "Adaptation",
        "Participation", "Limites", "Perspective", "Empressement", "Crise", "Principes", "Proposition", "Délégués",
        "Délégations", "Justice", "Alliance", "Pouvoir", "Années", "Peuple", "Unité", "Hypocrites", "Médiocres",
        "Faux", "Vrai", "Menteurs", "Irrationnel", "Peur", "Leadership", "Respect", "Danger", "Société",
        "Communauté internationale", "Travail", "Effort", "Lutte", "Engagement", "Evidence", "Inégalité",
        "Pays", "Objectifs", "Dilemme", "Éthique", "Morale", "Menace", "États", "Savoir", "Impérialisme",
        "Capitalisme", "Communisme", "Investissement", "Argent", "Session", "Autre", "Discours", "Nécessité", "Essentiel",
        "Impasse", "Traité", "Cité", "Dette", "Monde", "Corde", "Force", "Excellence"
    ],

    //Arabe 
    [
        "الاقتصاد" , "الأمم المتحدة" , "التغيير" , "الأجندة" , "المجتمع" , "السوط" , "المشكلة" , "الحل" ,
    "محفز" , "الجبهة" , "التهديد" , "الجهاز" , "الأمن" , "الوقت" , "الإستراتيجية" , "سهل" ,
    "صعب" , "خطر" , "مشكلة" , "منحرف" , "مربك" , "مثال" , "المنطقة" , "المسار" , "الجريمة" ,
    "الشدة" , "نفس" , "الهاوية" , "الأيديولوجيا" , "الاستقرار" , "التحليل" , "القوة" , "المستقبل" , "الحوار" ,
    "القانون الدولي" , "الصراع" , "التنمية" , "التعاون" , "السلام" , "الخبرة" , "البيانات" ,
    "الآليات" , "المؤسسات" , "الحكومة" , "التكنولوجيا" , "التعزيز" , "الحدود" , "التكيف" ,
    "المشاركة" , "القيود" , "المنظور" , "النغمة" , "الأزمة" , "المبادئ" , "الاقتراح" , "المندوبين" ,
    "الوفود" , "العدل" , "التحالف" , "السلطة" , "السنوات" , "الشعب" , "الوحدة" , "المنافقون" , "الوسطاء" ,
    "خطأ" , "صحيح" , "كذابون" , "غير عقلاني" , "خوف" , "قيادة" , "احترام" , "خطر" , "مجتمع" ,
    "المجتمع الدولي" , "العمل" , "الجهد" , "الكفاح" , "الالتزام" , "الدليل" , "عدم المساواة" ,
    "البلدان" , "الأهداف" , "المعضلة" , "الأخلاق" , "الأخلاق" , "التهديد" , "الدول" , "المعرفة" , "الإمبريالية" ,
    "الرأسمالية" , "الشيوعية" , "الاستثمار" , "المال" , "الدورة" , "مختلفة" , "الخطابات" , "الضرورة" , "الأساسية" ,
    "الجمود" , "المعاهدة" , "المنطقة" , "الديون" , "العالم" , "المشنقة" , "القوة" , "الامتياز"
    ],

    //Chino
    [
        "經濟","聯合國","變革","議程","社會","鞭毛","問題","解決方案",
    "催化劑","前線","威脅","機關","安全","時間","戰略","簡單",
    "困難","風險","問題","扭曲","令人困惑","示例","區域","路徑","犯罪",
    "浩瀚","相同","深淵","意識形態","穩定","分析","力量","未來","對話",
    "國際法","衝突","發展","合作","和平","經驗","數據",
    "機制","機構","政府","技術","加強","前沿","適應",
    "參與","局限","觀點","渴望","危機","原則","建議","代表",
    "代表團","正義","聯盟","權力","歲月","人民","團結","偽君子","平庸者",
    "假","真","騙子","非理性","恐懼","領導","尊重","危險","社會",
    "國際社會","工作","努力","鬥爭","承諾","證據","不平等",
    "國家","目標","困境","倫理","道德","威脅","國家","知識","帝國主義",
    "資本主義","共產主義","投資","金錢","會議","不同","演講","必要性","基本",
    "僵局","條約","區域","債務","世界","絞索","實力","卓越"
    ],

    //Ruso
    [
    "Экономика", "OOH", "Перемены", "Повестка дня", "Общество", "Жгутик", "Проблема", "Решение",
    "Катализатор", "Фронт", "Угроза", "Орган", "Безопасность", "Время", "Стратегия", "Легко",
    "Сложный", "Риск", "Проблема", "Перекос", "Запутанный", "Пример", "Область", "Путь", "Преступление",
    "Необъятность", "To же самое", "Бездна", "Идеология", "Стабильность", "Анализ", "Сила", "Будущее", "Диалог",
    "Международное право", "Конфликт", "Развитие", "Сотрудничество", "Мир", "Опыт", "Данные",
    "Механизмы", "Институты", "Правительство", "Технологии", "Укрепление", "Границы", "Адаптация",
    "Участие", "Ограничения", "Перспектива", "Стремление", "Кризис", "Принципы", "Предложение", "Делегаты",
    "Делегации", "Справедливость", "Альянс", "Власть", "Годы", "Народ", "Единство", "Лицемеры", "Бездари",
    "Ложь", "Правда", "Лжецы", "Иррациональность", "Страх", "Лидерство", "Уважение", "Опасность", "Общество",
    "Международное сообщество", "Работа", "Усилия", "Борьба", "Обязательство", "Доказательства", "Неравенство",
    "Страны", "Цели", "Дилемма", "Этика", "Мораль", "Угроза", "Государства", "Знание", "Империализм",
    "Капитализм", "Коммунизм", "Инвестиции", "Деньги", "Сессия", "Разное", "Речи", "Необходимость", "Насущное",
    "Туп", "Договор", "Участок", "Долг", "Мир", "Петля", "Сила", "Совершенство"
    ],

    //Portugues
    [
        "Economia", "ONU", "Mudança", "Agenda", "Sociedade", "Flagelo", "Problema", "Solução",
    "Catalisador", "Frente", "Ameaça", "Órgão", "Segurança", "Tempo", "Estratégia", "Fácil",
    "Difícil", "Risco", "Problema", "Desviado", "Confuso", "Exemplo", "Região", "Caminho", "Crime",
    "Imensidão", "Mesmo", "Abismo", "Ideologia", "Estabilidade", "Análise", "Poder", "Futuro", "Diálogo",
    "Direito Internacional", "Conflito", "Desenvolvimento", "Cooperação", "Paz", "Experiência", "Dados",
    "Mecanismos", "Instituições", "Governo", "Tecnologia", "Fortalecimento", "Fronteiras", "Adaptação",
    "Participação", "Limitações", "Panorama", "Ansiedade", "Crise", "Princípios", "Proposta", "Delegados",
    "Delegações", "Justiça", "Aliança", "Poder", "Anos", "Pessoas", "Unidade", "Hipócritas", "Medíocres",
    "Falso", "Verdadeiro", "Mentirosos", "Irracional", "Medo", "Liderança", "Respeito", "Perigo", "Sociedade",
    "Comunidade Internacional", "Trabalho", "Esforço", "Luta", "Compromisso", "Evidência", "Desigualdade",
    "Países", "Objetivos", "Dilema", "Ética", "Moral", "Ameaça", "Estados", "Conhecimento", "Imperialismo",
    "Capitalismo", "Comunismo", "Investimento", "Dinheiro", "Sessão", "Diferente", "Discursos", "Necessidade", "Essencial",
    "Impasse", "Tratado", "Precinct", "Dívida", "Mundo", "Noose", "Força", "Excelência"
    ],

    //Italiano
    [
    "Economia", "ONU", "Cambiamento", "Agenda", "Società", "flagellum", "Problema", "Soluzione",
    "Catalyst", "Front", "Threat", "Organ", "Security", "Time", "Strategy", "Easy",
    "Difficile", "Rischio", "Problema", "Distorto", "Confuso", "Esempio", "Regione", "Percorso", "Criminalità",
    "Immensità", "Stesso", "Abisso", "Ideologia", "Stabilità", "Analisi", "Potere", "Futuro", "Dialogo",
    "Diritto internazionale", "Conflitto", "Sviluppo", "Cooperazione", "Pace", "Esperienza", "Dati",
    "Meccanismi", "Istituzioni", "Governo", "Tecnologia", "Rafforzamento", "Frontiere", "Adattamento",
    "Partecipazione", "Limitazioni", "Prospettiva", "Desiderio", "Crisi", "Principi", "Proposta", "Delegati",
    "Delegazioni", "Giustizia","Alleanza", "Potere", "Anni", "Popolo", "Unità", "Ipocriti", "Mediocres",
    "False", "Vero", "Bugiardi", "Irrazionale", "Paura", "Leadership", "Rispetto", "Pericolo", "Società",
    "Comunità Internazionale", "Lavoro", "Sforzo", "Lotta", "Impegno", "Evidenza", "Disuguaglianza",
    "Paesi", "Obiettivi", "Dilemma", "Etica", "Morale", "Minaccia", "Stati", "Conoscenza", "Imperialismo",
    "Capitalismo", "Comunismo", "Investimento", "Denaro", "Sessione", "Diverso", "Discorsi", "Necessità", "Essenziale",
    "Stallo", "Trattato", "Recinto", "Debito", "Mondo", "Cappio", "Forza", "Eccellenza"
    ]
]

export const Topic = [
    //ESPAÑOL
    [
    "Cambio climático", "Seguridad", "Pobreza", "Hambruna",
    "Libertad de expresión", "Igualdad de género", "Conflictos bélicos","Ucrania vs Rusia", "Pandemia",
    "Inmigración", "Las drogas", "Globalización", "Aborto", "Pena de muerte", "Situacion en medio oriente",
    "Reforma del Consejo de seguridad", "Tráfico de armas", "Narcotráfico",
    "Tráfico de personas", "Seguridad Internacional", "Desarme de armas nucleares", "Desarrollo sustentable",
    "Discriminación etnica y/o religiosa", "Armas químicas", "Exploración espacial", "Islas Malvinas", "Crisis alimentaria",
    "Desarrollo digital", "Ciberseguridad", "Racismo"
    ],
    //INGLES
    [
        "Climate change", "Security", "Poverty", "Famine",
        "Freedom of expression", "Gender equality", "War conflicts","Ukraine vs Russia", "Pandemic",
        "Immigration", "Drugs", "Globalization", "Abortion", "Death penalty", "Situation in the Middle East",
        "Security Council Reform", "Arms Trafficking", "Drug Trafficking",
        "Human trafficking", "International Security", "Disarmament of nuclear weapons", "Sustainable development",
        "Ethnic and/or religious discrimination", "Chemical weapons", "Space exploration", "Malvinas Islands", "Food crisis",
        "Digital development", "Cybersecurity", "Racism"
    ],
    //FRANCES
    [
        "Changement climatique", "Sécurité ", "Pauvreté ", "Famine",
         "Liberté d'expression", "Egalité des genres", "Conflits de guerre", "Ukraine vs Russie", "Pandémie",
         "Immigration", "Drogues", "Mondialisation", "Avortement", "Peine de mort", "Situation au Moyen-Orient",
         "Réforme du Conseil de sécurité", "Trafic d'armes", "Trafic de drogue",
         "Traite des êtres humains", "Sécurité internationale", "Désarmement des armes nucléaires", "Développement durable",
         "Discrimination ethnique et/ou religieuse", "Armes chimiques", "Exploration spatiale", "Iles Malvinas", "Crise alimentaire",
         "Développement numérique", "Cybersécurité", "Racisme"
    ],

    //ARABE
    [
        "تغير المناخ" , "الأمن" , "الفقر" , "المجاعة" ,
         "حرية التعبير" , "المساواة بين الجنسين" , "نزاعات الحرب" , "أوكرانيا ضد روسيا" , "جائحة" ,
         "الهجرة" , "المخدرات" , "العولمة" , "الإجهاض" , "عقوبة الإعدام" , "الوضع في الشرق الأوسط" ,
         "إصلاح مجلس الأمن" , "الاتجار بالأسلحة" , "الاتجار بالمخدرات" ,
         "الاتجار بالبشر" , "الأمن الدولي" , "نزع الأسلحة النووية" , "التنمية المستدامة" ,
         "التمييز العرقي و / أو الديني" , "الأسلحة الكيميائية" , "استكشاف الفضاء" , "جزر مالفيناس" , "أزمة الغذاء" ,
         "التطور الرقمي" , "الأمن السيبراني" , "العنصرية"
    ],

    //Chino
    [
        "氣候變化","安全","貧困","飢荒",
         "言論自由","性別平等","戰爭衝突","烏克蘭對俄羅斯","大流行",
         "移民","毒品","全球化","墮胎","死刑","中東局勢",
         "安理會改革","武器販運","毒品販運",
         "販賣人口","國際安全","核武器裁軍","可持續發展",
         "種族和/或宗教歧視","化學武器","太空探索","馬爾維納斯群島","糧食危機",
         "數字發展","網絡安全","種族主義"
    ],

    //Ruso
    [
        "Изменение климата", "Безопасность", "Бедность", "Голод",
        "Свобода слова", "Гендерное равенство", "Военные конфликты", "Украина против России", "Пандемия",
        "Иммиграция", "Наркотики", "Глобализация", "Аборты", "Смертная казнь", "Ситуация на Ближнем Востоке",
        "Реформа Совета безопасности", "Незаконный оборот оружия", "Незаконный оборот наркотиков",
        "Торговля людьми", "Международная безопасность", "Разоружение ядерного оружия", "Устойчивое развитие",
        "Этническая и/или религиозная дискриминация", "Химическое оружие", "Освоение космоса", "Мальвинские острова", "Продовольственный кризис",
        "Цифровое развитие", "Кибербезопасность", "Расизм"
    ],

    //Portugues
    [
        "Mudanças climáticas", "Segurança", "Pobreza", "Fome",
        "Liberdade de expressão", "Igualdade de gênero", "Conflitos de guerra", "Ucrânia x Rússia", "Pandemia",
        "Imigração", "Drogas", "Globalização", "Aborto", "Pena de Morte", "Situação no Oriente Médio",
        "Reforma do Conselho de Segurança", "Tráfico de Armas", "Tráfico de Drogas",
        "Tráfico de pessoas", "Segurança Internacional", "Desarmamento de armas nucleares", "Desenvolvimento sustentável",
        "Discriminação étnica e/ou religiosa", "Armas químicas", "Exploração espacial", "Ilhas Malvinas", "Crise alimentar",
        "Desenvolvimento digital", "Segurança cibernética", "Racismo"
    ],

    //Italiano
    [
        "Cambiamento climatico", "Sicurezza", "Povertà", "carestia",
         "Libertà di espressione", "Parità di genere", "Conflitti di guerra", "Ucraina vs Russia", "Pandemia",
         "Immigrazione", "Droga", "Globalizzazione", "Aborto", "Pena di morte", "Situazione in Medio Oriente",
         "Riforma del Consiglio di sicurezza", "Traffico di armi", "Traffico di droga",
         "Tratta di esseri umani", "Sicurezza internazionale", "Disarmo delle armi nucleari", "Sviluppo sostenibile",
         "Discriminazione etnica e/o religiosa", "Armi chimiche", "Esplorazione spaziale", "Isole Malvinas", "Crisi alimentare",
         "Sviluppo digitale", "Cybersecurity", "Razzismo"
    ]
]


export const Phrases = [

    [
        "Muchas gracias delegado por realizar esa pregunta…",
        "Me permito agregar una cuestión a lo planteado por usted…",
        "Permítame diferenciarme…",
        "No estoy de acuerdo con lo que plantea…",
        "Su pregunta es parte de un problema mayor…",
        "Su pregunta es una excelente oportunidad para aclararle al organo…",
        "La pregunta que me hace es irrelevante para la discusión que estamos teniendo aquí…",
        "Delegado,me permito informarle…",
        " No estoy de acuerdo con lo que plantea… ",
        "Su pregunta desconoce…",
        "Me es grato aclarar…",
        "Nos encontramos ante un problema de difícil solución…",
        "Es imprescindible que…",
        "Celebro con beneplácito…",
        "Antes que nada debemos considerar…",
        "No es casual que surja esta cuestión aquí…",
        "Lamento comunicarle…",
        "Por fortuna…",
        "Es prioridad que hallemos una solución a lo planteado por usted…",
        "Es ineludible que nos detengamos…",
        "No debemos olvidar…",
        "Gratamente delegado, el tiempo es nuestro aliado en esta lucha contra…",
        "Contestar esta pregunta nos obliga a…",
        "Me gustaría oír más voces en ese sentido pero…",
        "Es lamentable que hoy en día sigamos debatiendo sobre estas cuestiones…",
        "No es casual que…",
        "Mi país no es el único afectado por esta situación…",
        "Debemos mirar dicho asunto desde otra perspectiva…",
        "Debemos reflexionar sobre las circunstancias que condujeron esta situación hasta aquí…",
        "No dejo de asombrarme por su planteo…",
        "Delegado su mirada en esta cuestion es erronea..."
    ],
    //INGLES

    ["Thank you very much delegate for asking that question…",
    "Allow me to add a question to what you raised…",
    "Allow me to differentiate myself…",
    "I do not agree with what you have said",
    "Your question is part of a bigger problem…",
    "Your question is an excellent opportunity to clarify to the organ…",
    "The question you're asking me is irrelevant to the discussion we're having here…",
    "Delegate, may I inform you…",
    "I do not agree with what you are proposing…",
    "Your question shows ignorance…",
    "I am pleased to clarify…",
    "We are faced with a problem that is difficult to solve…",
    "It is essential that…",
    "First of all we must consider…",
    "It is no coincidence that this question arises here…",
    "I am sorry to tell you…",
    "I welcome your question",
    "Fortunately…",
    "It is a priority that we find a solution to what you have raised…",
    "It is unavoidable that we stop…",
    "We must not forget…",
    "Pleasant delegate, time is our ally in this fight against…",
    "Answering this question forces us to…",
    "I would like to hear more voices in that sense but…",
    "It is unfortunate that today we continue to debate these issues…",
    "It is no coincidence that…",
    "My country is not the only one affected by this situation…",
    "We must look at this matter from another perspective…",
    "We must reflect on the circumstances that led this situation to here…",
    "I can't help but be amazed by your approach…",
    "Delegate, your view on this matter is wrong..."
    
    ],

    //FRANCES
    [
        "Merci beaucoup, délégué, d'avoir posé cette question…",
        "Permettez-moi d'ajouter une question à ce que vous avez soulevé…",
        "Permettez-moi de me différencier…",
        "Je ne suis pas d'accord avec ce que vous avez dit",
        "Votre question fait partie d'un problème plus vaste…",
        "Votre question est une excellente occasion de clarifier à l'organe…",
        "La question que vous me posez n'a rien à voir avec la discussion que nous avons ici…",
        "Délégué, puis-je vous informer…",
        "Je ne suis pas d'accord avec ce que vous proposez…",
        "Votre question montre l'ignorance…",
        "Je suis heureux de clarifier…",
        "Nous sommes face à un problème difficile à résoudre…",
        "Il est essentiel que…",
        "Tout d'abord, nous devons considérer…",
        "Ce n'est pas un hasard si cette question se pose ici…",
        "Je suis désolé de vous dire…",
        "Je me réjouis de votre question",
        "Heureusement…",
        "C'est une priorité que nous trouvions une solution à ce que vous avez soulevé…",
        "Il est inévitable que nous arrêtions… ",
        "Il ne faut pas oublier…",
        "Agréable délégué, le temps est notre allié dans ce combat contre… ",
        "Répondre à cette question nous oblige à…",
        "J'aimerais entendre plus de voix dans ce sens mais...",
        "Il est regrettable qu'aujourd'hui nous continuions à débattre de ces questions…",
        "Ce n'est pas un hasard si…",
        "Mon pays n'est pas le seul touché par cette situation…",
        "Il faut voir cette affaire sous un autre angle… ",
        "Il faut réfléchir aux circonstances qui ont conduit cette situation ici…",
        "Je ne peux pas m'empêcher d'être émerveillé par votre approche…",
        "Délégué, votre point de vue sur cette question est erroné..."
    ],

    //Arabe 
    [
        "شكرًا جزيلاً أيها المندوب على طرح هذا السؤال ..." ,
    "اسمح لي أن أضيف سؤالاً إلى ما طرحته ..." ,
    "اسمح لي أن أميز نفسي ..." ,
    "أنا لا أتفق مع ما قلته" ,
    "سؤالك جزء من مشكلة أكبر…" ,
    "سؤالك فرصة ممتازة للتوضيح للعضو ..." ,
    "السؤال الذي تطرحه علي غير ذي صلة بالمناقشة التي نجريها هنا ..." ,
    "مندوب , هل لي أن أبلغكم ..." ,
    "أنا لا أتفق مع ما تقترحه ..." ,
    "سؤالك يظهر الجهل ..." ,
    "يسعدني أن أوضح ..." ,
    "نواجه مشكلة يصعب حلها ..." ,
    "فمن الضروري أن…",
    "بادئ ذي بدء , يجب أن نأخذ في الاعتبار ..." ,
    "ليس من قبيل المصادفة أن يطرح هذا السؤال هنا ..." ,
    "أنا آسف لإخبارك ..." ,
    "أرحب بسؤالك" ,
    "لحسن الحظ…",
    "من الأولويات أن نجد حلاً لما أثرته ..." ,
    "لا مفر من أن نتوقف ..." ,
    "يجب ألا ننسى ..." ,
    "مندوب لطيف , الوقت حليفنا في هذه المعركة ضد ..." ,
    "الإجابة على هذا السؤال تجبرنا على ..." ,
    "أود سماع المزيد من الأصوات بهذا المعنى ولكن ..." ,
    "من المؤسف أن نواصل اليوم مناقشة هذه القضايا ..." ,
    "ليس من قبيل المصادفة أن ..." ,
    "بلدي ليس الوحيد المتضرر من هذا الوضع ..." ,
    "يجب أن ننظر إلى هذا الأمر من منظور آخر ..." ,
    "يجب أن نفكر في الظروف التي أدت بهذا الوضع إلى هنا ..." ,
    "لا يسعني إلا أن أذهل بنهجك ..." ,
    "مندوب , وجهة نظرك في هذا الأمر خاطئة ..."
    ],

    //Chino
    [
    "非常感謝代表提出這個問題……",
    "請允許我在你提出的內容中添加一個問題......",
    "請允許我區分自己……",
    "我不同意你所說的",
    "你的問題是更大問題的一部分……",
    "你的問題是向機關澄清的絕好機會……",
    "你問我的問題與我們在這裡的討論無關……",
    "代表,我可以通知您……",
    "我不同意你的提議……",
    "你的問題顯示無知......",
    "我很高興澄清......",
    "我們面臨一個難以解決的問題……",
    "這很重要……",
    "首先我們必須考慮……",
    "這裡出現這個問題並非巧合……",
    "很抱歉告訴你……",
    "我歡迎你的問題",
    "幸運的是…",
    "我們的首要任務是為您提出的問題找到解決方案……",
    "我們不可避免地要停下來……",
    "我們不能忘記……",
    "愉快的代表,時間是我們對抗……的盟友",
    "回答這個問題迫使我們……",
    "我想在這個意義上聽到更多的聲音,但是……",
    "不幸的是,今天我們繼續辯論這些問題……",
    "這不是巧合……",
    "我的國家不是唯一受到這種情況影響的國家……",
    "我們必須從另一個角度看待這件事……",
    "我們必須反思導致這種情況出現在這裡的情況……",
    "我不禁對你的做法感到驚訝……",
    "代表,你對這件事的看法是錯誤的……"
    ],

    //Ruso
    [
        "Большое спасибо делегату за вопрос…",
        "Позвольте мне добавить вопрос к тому, что вы подняли…",
        "Позвольте мне выделиться…",
        "Я не согласен c тем, что вы сказали",
        "Ваш вопрос — часть большой проблемы…",
        "Ваш вопрос — отличный повод уточнить перед органом…",
        "Вопрос, который вы мне задаете, не имеет отношения к нашей дискуссии…",
        "Делегат, могу я сообщить вам…",
        "Я не согласен c тем, что вы предлагаете…",
        "Ваш вопрос свидетельствуето невежестве…",
        "Рад пояснить…",
        "Мы столкнулись c проблемой, которую трудно решить…",
        "Необходимо, чтобы…",
        "Прежде всего мы должны рассмотреть…",
        "Неслучайно здесь возникает этот вопрос…",
        "Мне жаль говорить вам…",
        "Я приветствую ваш вопрос",
        "K счастью…",
        "Приоритетом является то, что мы находим решение того, что вы подняли…",
        "Неизбежно, что мы остановимся…",
        "Мы не должны забывать…",
        "Приятный делегат, время — наш союзник в этой борьбе с…",
        "Ответ на этот вопрос заставляет нас…",
        "Я хотел бы услышать больше голосов в этом смысле, но…",
        "Очень жаль, что сегодня мы продолжаем дискутировать по этим вопросам…",
        "He случайно…",
        "Моя страна не единственная, кого затронула эта ситуация…",
        "Мы должны посмотреть на этот вопрос c другой точки зрения…",
        "Мы должны задуматься над обстоятельствами, которые привели эту ситуацию сюда…",
        "He могу не восхищаться вашим подходом…",
        "Делегат, ваше мнение по этому вопросу неверно..."   
    ],

    //Portugues
    [
    "Muito obrigado delegado por fazer essa pergunta...",
    "Permita-me adicionar uma pergunta ao que você levantou ...",
    "Permita-me diferenciar-me…",
    "Não concordo com o que você disse",
    "Sua pergunta faz parte de um problema maior...",
    "Sua pergunta é uma excelente oportunidade de esclarecimento ao órgão...",
    "A pergunta que você está me fazendo é irrelevante para a discussão que estamos tendo aqui...",
    "Delegado, posso informá-lo…",
    "Não concordo com o que você está propondo...",
    "Sua pergunta mostra ignorância...",
    "Tenho o prazer de esclarecer...",
    "Estamos diante de um problema difícil de resolver...",
    "É essencial que...",
    "Em primeiro lugar, devemos considerar…",
    "Não é por acaso que esta questão surge aqui...",
    "Lamento dizer-lhe...",
    "Congratulo-me com a sua pergunta",
    "Felizmente…",
    "É uma prioridade que encontremos uma solução para o que você levantou...",
    "É inevitável que paremos...",
    "Não devemos esquecer...",
    "Delegado simpático, o tempo é nosso aliado nesta luta contra...",
    "Responder a esta pergunta obriga-nos a…",
    "Gostaria de ouvir mais vozes nesse sentido, mas...",
    "É lamentável que hoje continuemos a debater estas questões...",
    "Não é por acaso que...",
    "O meu país não é o único afetado por esta situação...",
    "Devemos olhar para este assunto de outra perspectiva ...",
    "Devemos refletir sobre as circunstâncias que levaram esta situação até aqui…",  "Eu não posso deixar de me surpreender com sua abordagem ...",
    "Delegado, sua opinião sobre este assunto está errada..."
    ],

    //Italiano
    [
        "Grazie mille delegato per aver posto questa domanda...",
    "Permettimi di aggiungere una domanda a ciò che hai sollevato...",
    "Permettimi di differenziarmi...",
    "Non sono d'accordo con quello che hai detto",
    "La tua domanda fa parte di un problema più grande...",
    "La tua domanda è un'ottima occasione per chiarire all'organo...",
    "La domanda che mi stai ponendo è irrilevante per la discussione che stiamo avendo qui...",
    "Delegato, posso informarla...",
    "Non sono d'accordo con quello che stai proponendo...",
    "La tua domanda mostra ignoranza...",
    "Sono lieto di chiarire...",
    "Ci troviamo di fronte a un problema difficile da risolvere...",
    "È essenziale che...",
    "Prima di tutto dobbiamo considerare...",
    "Non è un caso che questa domanda si presenti qui...",
    "Mi dispiace dirtelo...",
    "Accolgo con favore la tua domanda",
    "Fortunatamente…",
    "È una priorità trovare una soluzione a ciò che hai sollevato...",
    "È inevitabile che ci fermiamo...",
    "Non dobbiamo dimenticare...",
    "Piacevole delegato, il tempo è nostro alleato in questa lotta contro...",
    "Rispondere a questa domanda ci obbliga a...",
    "Vorrei sentire più voci in questo senso ma...",
    "È un peccato che oggi continuiamo a discutere di questi problemi...",
    "Non è un caso che...",
    "Il mio Paese non è l'unico colpito da questa situazione...",
    "Dobbiamo guardare a questo problema da un'altra prospettiva...",
    "Dobbiamo riflettere sulle circostanze che hanno portato questa situazione fin qui...",
    "Non posso fare a meno di rimanere stupito dal tuo approccio...",
    "Delegato, la sua opinione su questo argomento è sbagliata..."
    ]
]


